import { useState, useEffect } from 'react'
import { Wifi, WifiOff } from 'lucide-react'
import { isOnline, onOnlineStatusChange } from '../utils/offline'

export function OfflineIndicator() {
  const [online, setOnline] = useState(isOnline())

  useEffect(() => {
    onOnlineStatusChange(setOnline)
  }, [])

  if (online) return null

  return (
    <div className="fixed top-0 left-0 right-0 bg-orange-500 text-white px-4 py-2 z-50 flex items-center justify-center">
      <WifiOff size={16} className="mr-2" />
      <span className="text-sm">오프라인 모드입니다. 일부 기능이 제한될 수 있습니다.</span>
    </div>
  )
}

